import MainTitle from "@/components/MainTitle";
import CardList from "@/pages/blog-news/CardList";
import { Row, Col, Input, Button, Space } from 'antd';
import { useEffect, useState } from "react";
import classNames from "classnames";
import styles from "./index.module.scss";
import { news_list } from "@/apis/news";
import intl from "react-intl-universal";

const News = () => {
	const [params, setParams] = useState({
		keywords: ""
	})

	const [pageParam, setPageParam] = useState({
		pageSize: 10,
		currentPage: 1,
	})
	const [list, setList] = useState([])
	const [total, setTotal] = useState(0)

	const getList = () => {
		news_list({
			...pageParam,
			...params,
			status: 1
		}).then(res => {
			const arr = res.data.records.map(item => {
				return {
					id: item.newsUuid,
					type: item.newsType,
					title: item.title,
					des: item.text,
					date: item.phenomenonTime,
					link: item.link,
					imgPath: item.cover?.filePath,
				}
			})
			setList(arr);
			setTotal(res.data.total)
		}).catch(err => { })
	}

	useEffect(() => {
		getList()
	}, [pageParam])

	const handleKeyDown = (e) => {
		if (e.keyCode === 13) {
			setPageParam({
				currentPage: 1,
				pageSize: 10,
			})
		}
	}

	const handelQuery = () => {
		setPageParam({
			currentPage: 1,
			pageSize: 10,
		})
	}

	return (
		<div className={classNames("container", styles.newsBox)}>
			<MainTitle title="News" />
			<Row gutter={30} className={styles.rowBox}>
				<Col span={24}>
					<Space.Compact size="large" style={{ width: '100%' }}>
						<Input
							allowClear
							placeholder={intl.get("Title")}
							onKeyDown={handleKeyDown}
							onChange={(e) => {
								setParams({ keywords: e.target.value })
							}} />
						<Button type="primary" onClick={handelQuery}>{intl.get("Search")}</Button>
					</Space.Compact>
				</Col>
			</Row>
			<CardList list={list} total={total} pageParam={pageParam} setPageParam={setPageParam} type="NEWS" />
		</div>
	);
}
export default News;